import { Link, useLocation } from "react-router-dom";

const NAV = [
    { label: "Overview", to: "/release?tab=overview" },
    { label: "Change Package", to: "/release?tab=package" },
    { label: "Local Impact", to: "/release?tab=impact" },
    { label: "Rollout", to: "/release?tab=rollout" },
    { label: "Installation", to: "/release?tab=install" },
    { label: "Service Release", to: "/release?tab=service" },
    { label: "Receipts", to: "/receipts" },
    { label: "Architecture", to: "/architecture" },
];

export const TcrLayout = ({ children }) => {
    const { pathname, search } = useLocation();
    const current = `${pathname}${search}`;
    const isActive = (to) =>
        to.startsWith("/release")
            ? current === to || (pathname === "/release" && !search && to.endsWith("overview"))
            : pathname === to;

    return (
        <div className="flex min-h-screen flex-col bg-slate-50">
            <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/90 backdrop-blur">
                <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-3.5">
                    <Link to="/" data-testid="brand-link" className="flex shrink-0 items-center gap-2.5">
                        <span className="grid h-7 w-7 place-items-center rounded-sm bg-blue-950 text-white">
                            <span className="font-mono text-[13px] leading-none">K</span>
                        </span>
                        <span className="flex flex-col leading-tight">
                            <span className="text-sm font-medium tracking-tight text-slate-900">KATLAS</span>
                            <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-400">
                                Trusted Change Release
                            </span>
                        </span>
                    </Link>
                    <nav className="hidden items-center gap-0.5 lg:flex">
                        {NAV.map((n) => (
                            <Link
                                key={n.to}
                                to={n.to}
                                data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                                className={`whitespace-nowrap rounded-sm px-2.5 py-1.5 text-[13px] transition-colors duration-150 ${
                                    isActive(n.to)
                                        ? "bg-slate-100 text-slate-900"
                                        : "text-slate-500 hover:bg-slate-50 hover:text-slate-900"
                                }`}
                            >
                                {n.label}
                            </Link>
                        ))}
                    </nav>
                </div>
            </header>

            <main className="mx-auto w-full max-w-6xl flex-1 px-6 py-10">{children}</main>

            <footer className="border-t border-slate-200 bg-white">
                <div className="mx-auto flex max-w-6xl flex-col gap-4 px-6 py-6 text-xs text-slate-400 sm:flex-row sm:items-center sm:justify-between">
                    <p className="max-w-xl leading-relaxed">
                        Synthetic healthcare-technology demonstrator. No patient data,
                        clinical records, live hospital systems, real devices or supplier
                        documents. Not a certification or regulatory approval.
                    </p>
                    <div className="flex shrink-0 items-center gap-4">
                        <Link
                            to="/diagnostics"
                            data-testid="footer-diagnostics-link"
                            className="font-mono text-slate-400 hover:text-slate-700"
                        >
                            Diagnostics
                        </Link>
                        <span data-testid="live-node-pill" className="inline-flex items-center gap-2 font-mono tracking-tight text-slate-500">
                            <span className="h-2 w-2 rounded-full bg-slate-400" />
                            Live node connection not configured
                        </span>
                    </div>
                </div>
            </footer>
        </div>
    );
};
